import { FaTimesCircle } from "react-icons/fa";
import {
  FundsSafeMessage,
  ResultStatusIcon,
  SummaryRow,
  TransactionDetailsCard,
} from "../../../shared/result/ResultPrimitives";
import {
  formatDateTimeToLocale,
  formatKES,
} from "../../../../utils/transactionutils";
import { contactSupport } from "../../../../utils/supportUtils";
import CustomButton from "../../../ui/CustomButton/CustomButton";
import CustomNotificationBanner from "../../../ui/CustomNotificationBanner/CustomNotificationBanner";

export function FailedView({
  amount,
  transactionId,
  createdDate,
  transactionFee,
  newBalance,
  remarks,
  onNewWithdrawal,
}) {
  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex flex-col items-center text-center gap-3">
        <ResultStatusIcon
          icon={FaTimesCircle}
          bgClassName="bg-red-50"
          iconClassName="text-red-500"
        />
        <p className="text-sm sm:text-base font-semibold text-red-600">
          Withdrawal Failed!
        </p>
      </div>

      <div className="w-full max-w-sm mx-auto">
        <CustomNotificationBanner
          variant="error"
          title="Reason:"
          titleColor="var(--mantine-color-red-6)"
          message={remarks ?? "The withdrawal could not be processed."}
          withCloseButton={false}
        />
      </div>

      <FundsSafeMessage
        amount={formatKES(amount)}
        balance={formatKES(newBalance)}
      />

      <TransactionDetailsCard>
        {transactionId && (
          <SummaryRow label="Transaction ID" value={transactionId} stacked />
        )}
        <SummaryRow label="Attempted Amount" value={formatKES(amount)} />
        {createdDate && (
          <SummaryRow
            label="Date"
            value={formatDateTimeToLocale(createdDate)}
          />
        )}
        <SummaryRow label="Transaction Fee" value={formatKES(transactionFee)} />
        <SummaryRow label="Current Balance" value={formatKES(newBalance)} />
      </TransactionDetailsCard>

      <div className="w-full max-w-sm mx-auto flex gap-2">
        <CustomButton
          color="primary"
          radius="md"
          className="flex-1"
          onClick={onNewWithdrawal}
        >
          Try Again
        </CustomButton>
        <CustomButton
          variant="outline"
          color="gray"
          radius="md"
          className="flex-1"
          onClick={() => contactSupport()}
        >
          Contact Support
        </CustomButton>
      </div>
    </div>
  );
}
